import { Component, Output, EventEmitter, HostListener } from '@angular/core';
import { CaseDocumentService } from 'src/app/services/documents.service';
import { ESCAPE } from "@angular/cdk/keycodes";
import { ServiceRequestsService } from 'src/app/services/service-requests.service';

@Component({
	selector: 'app-caseavatarpreview',
	templateUrl: './caseavatarpreview.component.html',
	styleUrls: ['./caseavatarpreview.component.css']
})
export class CaseavatarpreviewComponent {

	public documentPreviewUrl: string | null = null;
	@Output() cancelClicked = new EventEmitter();

	constructor(private serviceRequestsService: ServiceRequestsService) {
	}

	public ngOnInit() {

	}
	onShowHandler(caseId: number, type: string = 'image') {
		if (caseId === 0 || caseId === undefined) {
			return;
		}
		try {
			this.serviceRequestsService.getCaseAvatarImage(caseId).subscribe(
				(data) => {
					if (data && data.size > 4) { // Check if data is valid
						const blob = new Blob([data], { type: (type === 'pdf' ? 'application/pdf' : 'image/jpeg') });
						const url = this.createDataUrl(blob, type); // Create a data URL
						this.documentPreviewUrl = url;
					} else {
						this.handleNoValidData();
					}
				},
				(error) => {
					this.handleNoValidData();
				}
			);
		} catch (Exception) {
			this.handleNoValidData();
		}
	}

	private createDataUrl(data: any, type: string): string {
		const blob = new Blob([data], { type: (type == 'pdf' ? 'application/pdf' : 'image/jpeg') });
		return URL.createObjectURL(blob);
	}
	closeHandler() {
		this.cancelClicked.emit();
	}
	
	 private handleNoValidData() {
    this.documentPreviewUrl = './assets/img_na.png';
    //this.closeHandler();
  }
}
